'use client';

import { usePathname } from 'next/navigation';

// Hides the public site chrome (Header / Footer / ChatBot) on the /admin area,
// which provides its own layout.
export default function HideOnAdmin({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (pathname?.startsWith('/admin')) return null;
  return <>{children}</>;
}
